<template>
  <div class="wrapper" v-loading="ifRequesting">
    <div class="searchBar">
      <div>
        证书编号
        <el-input
          placeholder="搜索证书编号"
          size="small"
          style="width: 160px"
          v-model="searchCondition.certificateNum"
        ></el-input>
        &ensp;&ensp; 姓名：
        <el-input
          placeholder="搜索姓名"
          size="small"
          style="width: 160px"
          v-model="searchCondition.userName"
        ></el-input>
        &ensp;&ensp; 身份证：
        <el-input
          placeholder="搜索身份证号"
          size="small"
          style="width: 160px"
          v-model="searchCondition.idCard"
        ></el-input>
        &ensp;&ensp; 审核人：
        <el-input
          placeholder="审核人"
          size="small"
          style="width: 160px"
          v-model="searchCondition.auditorText"
        ></el-input
        ><br />
        <br />
        审核状态：
        <el-select
          placeholder="审核状态"
          v-model="searchCondition.auditStatus"
          size="small"
        >
          <el-option value="" label="所有审核状态"></el-option>
          <el-option value="toBeAudit" label="待审核"></el-option>
          <el-option value="auditOk" label="审核通过"></el-option>
          <el-option
            value="auditNotOk"
            label="审核不通过"
          ></el-option> </el-select
        >&ensp;&ensp; 对比状态：
        <el-select
          placeholder="对比状态"
          v-model="searchCondition.comparedStatus"
          size="small"
        >
          <el-option value="" label="所有比对状态"></el-option>
          <el-option value="0" label="待对比"></el-option>
          <el-option value="1" label="对比成功"></el-option>
          <el-option value="2" label="对比失败"></el-option>
        </el-select>

        &ensp;&ensp; 证书类型：
        <el-select
          placeholder="请选择证书类型"
          v-model="searchCondition.source"
          size="small"
        >
          <el-option value="" label="所有证书类型"></el-option>
          <el-option :value="1" label="考试"></el-option>
          <el-option :value="2" label="转换评价"></el-option>
        </el-select>
        &ensp;&ensp;起始时间：
        <el-date-picker
          style="width: 200px"
          size="small"
          v-model="searchCondition.rangeTime"
          type="daterange"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="
            (value) => {
              [searchCondition.startTime, searchCondition.endTime] = value || [
                '',
                '',
              ];
            }
          "
        >
        </el-date-picker>
        <!-- <el-date-picker
          type="date"
          placeholder="上传登记时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchCondition.createTime"
        >
        </el-date-picker> -->

        &ensp;&ensp;
        <el-button type="primary" size="small" @click="getData">查询</el-button>
        <el-button
          type="primary"
          size="small"
          @click="
            Object.assign(searchCondition, $options.data().searchCondition)
          "
          >重置</el-button
        >
      </div>
    </div>
    <div class="content">
      <div class="actBar">
        <!-- <div>
          <el-upload
            action="/base/common/importAuditExcel"
            :show-file-list="false"
            :on-success="importSuccess"
            :before-upload="
              () => {
                ifRequesting = true;
              }
            "
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </div> -->
        <div>
          <el-upload
            action="/base/common/comparativeData"
            :show-file-list="false"
            :on-success="importSuccess"
            :headers="{ Authorization: getStore('accessToken') }"
            :before-upload="
              () => {
                ifRequesting = true;
              }
            "
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <el-button size="small" type="primary">导入比对名单</el-button
            >&emsp;&emsp;
            <el-button size="small" @click="download">下载比对模板</el-button>
          </el-upload>
        </div>

        <div>
          <!-- <el-button
            slot="reference"
            :disabled="selectList.length == 0"
            @click="
              auditDialogIfShow = true;
              auditRemark = '';
              auditData = null;
            "
            >一键审核</el-button
          > -->

          <el-dropdown
            @command="
              (command) => {
                auditDialogIfShow = true;
                auditRemark = '';
                auditData = null;
                auditIfSelect = command;
              }
            "
          >
            <el-button size="small"> 审核 </el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="true"
                :disabled="selectList.length == 0"
                >审核勾选项</el-dropdown-item
              >
              <el-dropdown-item
                :command="false"
                :disabled="searchCondition.total == 0"
                >审核当前筛选下所有项</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          @selection-change="
            (e) => {
              selectList = e;
            }
          "
          border
          style="width: 100%"
          ref="transformTable"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column
            type="selection"
            width="40px"
            :selectable="(item) => item.auditStatus == 1 && item.type == 1"
          >
          </el-table-column>

          <el-table-column
            prop="certificateName"
            label="证书名称"
            width="120px"
          >
          </el-table-column>
          <el-table-column prop="userName" label="学员姓名" width="80px">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180px">
          </el-table-column>

          <el-table-column prop="certificateNum" label="证书编号" width="160px">
          </el-table-column>
          <el-table-column prop="sourceText" label="证书类型" width="160px">
          </el-table-column>
          <el-table-column prop="validity" label="有效期" width="100px">
          </el-table-column>
          <el-table-column prop="award" label="颁发机构" min-width="160px">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120px">
          </el-table-column>
          <el-table-column prop="createTime" label="上传登记时间" width="105px">
          </el-table-column>
          <el-table-column
            label="审核状态"
            width="100px"
            prop="auditStatusText"
          >
          </el-table-column>
          <el-table-column prop="auditor" label="审核人" min-width="100px">
          </el-table-column>
          <el-table-column prop="auditTime" label="审核时间" min-width="100px">
          </el-table-column>
          <el-table-column
            prop="comparedStatusText"
            label="比对状态"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column align="center" width="180" label="操作">
            <template slot-scope="{ row }">
              <el-button size="small" @click="previewCertificate(row)">
                预览</el-button
              >&ensp;

              <el-button
                slot="reference"
                size="small"
                :disabled="!(row.auditStatus == 1 && row.type == 1)"
                @click="
                  auditDialogIfShow = true;
                  auditRemark = '';
                  auditData = row;
                "
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <el-image-viewer
      v-if="previewImageList.length > 0"
      :on-close="
        () => {
          previewImageList = [];
        }
      "
      :url-list="previewImageList"
    /> -->
    <el-dialog
      title="证书预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
    <el-dialog
      title="审核意见"
      append-to-body
      :visible.sync="auditDialogIfShow"
      width="40%"
    >
      <div>
        当前选择
        {{
          auditData
            ? 1
            : this.auditIfSelect
            ? selectList.length
            : this.searchCondition.total
        }}
        条记录
      </div>
      <div class="dialogContent">
        <el-input placeholder="请输入审核意见" v-model="auditRemark"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="auditSubmit('auditOk')"
          >通过</el-button
        >
        <el-button size="small" type="danger" @click="auditSubmit('auditNotOk')"
          >拒绝</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import elImageViewer from "element-ui/packages/image/src/image-viewer";
import Util from "@/libs/util";
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

import {
  certificateAuditList,
  certificateAudit,
  previewCertificate,
  //   exportCertificateTransform,
} from "@/api/certificate.js";
export default {
  data() {
    return {
      ifRequesting: false,
      dataList: [],
      selectList: [],
      previewImageList: [],
      searchCondition: {
        type: 2,
        source: "",
        certificateNum: "",
        userName: "",
        idCard: "",
        auditStatus: "",
        auditorText: "",
        pageNumber: 1,
        pageSize: 10,
        rangeTime: "",
        startTime: "",
        endTime: "",
        createTime: "",
        comparedStatus: "",
      },
      auditLock: false,
      auditDialogIfShow: false,
      auditIfSelect: false,
      auditRemark: "",
      auditData: {},
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  components: { elImageViewer, pdfPreview },
  methods: {
    previewCertificate(item) {
      this.ifRequesting = true;
      previewCertificate({ id: item.id }).then((data) => {
        if (data.code == 200) {
          this.pdfData.pdfUrl = data.data;
          this.pdfData.pdfIfShow = true;
          this.ifRequesting = false;
        }
      });
    },
    importSuccess(res, file) {
      this.ifRequesting = false;
      console.log(res);
      if (res.code == 200) {
        this.$alert(res.info, "提示");
        if (res.data) {
          location.href = res.data;
        }
        this.getData();
      } else {
        this.$alert(res.info, "提示");
      }
    },
    download() {
      location.href = "../证书导入模板.xlsx";
    },
    // previewImage(urlList) {
    //   if (urlList[0]) {
    //     this.previewImageList = urlList;
    //   } else {
    //     this.$message.warning("此申请没有提供图片数据");
    //   }
    // },
    getData() {
      let postData = {};
      for (const i in this.searchCondition) {
        if (this.searchCondition[i] || this.searchCondition[i] === 0) {
          postData[i] = this.searchCondition[i];
        }
      }
      this.ifRequesting = true;
      certificateAuditList(postData).then((data) => {
        // data.rows.forEach((item) => {
        //   item.auditRemark = "";
        // });
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        this.auditLock = false;
        this.ifRequesting = false;
      });
    },
    // auditSubmit(status) {
    //   if (this.auditLock) {
    //     return;
    //   }

    //   this.auditLock = true;
    //   let item = this.auditData || null;
    //   console.log(item);
    //   certificateAudit({
    //     auditIds: item ? [item.id] : this.selectList.map((item) => item.id),
    //     auditStatus: status,
    //     type: this.searchCondition.type,
    //     auditRemark: this.auditRemark,
    //   }).then((data) => {
    //     this.$message.success("审核成功");
    //     this.getData();
    //     this.auditDialogIfShow = false;
    //   });
    // },

    auditSubmit(status) {
      if (this.auditLock) {
        return;
      }

      this.auditLock = true;
      let item = this.auditData || null;
      console.log(item);

      let postData = {
        auditFinalStatus: status,
        type: this.searchCondition.type,
        auditRemark: this.auditRemark,
      };
      if (item) {
        postData.auditIds = [item.id];
      } else if (this.auditIfSelect) {
        postData.auditIds = this.selectList.map((item) => item.id);
      } else {
        Object.assign(postData, this.searchConditionUsed);
      }

      certificateAudit(postData).then((data) => {
        this.$message.success("审核成功");
        this.getData();
        this.auditDialogIfShow = false;
      });
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
